(() => {
  'use strict';

  const configElement = document.getElementById('wallify-delivery-return-config');
  if (!configElement || window.wallifyDeliveryReturnInitialized) return;

  let config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (_) {
    return;
  }
  window.wallifyDeliveryReturnInitialized = true;

  const storageKey = 'wallify:delivery-return:v1';
  const maxAge = 30 * 60 * 1000;
  const origin = window.location.origin;
  const productPath = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9][a-z0-9-]*\/?$/i;

  function sameOriginUrl(value) {
    if (typeof value !== 'string' || !value || value.length > 8192 || /[\\\u0000-\u0020]/.test(value)) return null;
    try {
      const url = new URL(value, origin);
      if (url.origin !== origin || url.username || url.password || !/^https?:$/.test(url.protocol)) return null;
      return url;
    } catch (_) {
      return null;
    }
  }

  function productUrl(value) {
    const url = sameOriginUrl(value);
    if (!url || !productPath.test(url.pathname)) return null;
    return url.pathname + url.search + url.hash;
  }

  const normalizePath = (path) => path.replace(/\/$/, '');
  const shippingPaths = new Set(
    (Array.isArray(config.shippingUrls) ? config.shippingUrls : [])
      .map(sameOriginUrl)
      .filter(Boolean)
      .map((url) => normalizePath(url.pathname))
  );

  function shippingUrl(value) {
    const url = sameOriginUrl(value);
    return url && shippingPaths.has(normalizePath(url.pathname)) ? url : null;
  }

  function currentProduct() {
    return config.isProduct ? productUrl(window.location.href) : null;
  }

  function rememberProduct(value) {
    if (!value) return;
    try {
      sessionStorage.setItem(storageKey, JSON.stringify({ url: value, at: Date.now() }));
    } catch (_) {
      // The explicit return link also works when storage is unavailable.
    }
  }

  function storedProduct() {
    try {
      const record = JSON.parse(sessionStorage.getItem(storageKey));
      if (!record || typeof record.at !== 'number') return null;
      const age = Date.now() - record.at;
      if (age < 0 || age > maxAge) {
        sessionStorage.removeItem(storageKey);
        return null;
      }
      return productUrl(record.url);
    } catch (_) {
      return null;
    }
  }

  function decorateLink(link) {
    const source = currentProduct();
    if (!source || !link || !link.matches('a[href]')) return;
    const target = shippingUrl(link.getAttribute('href'));
    if (!target) return;
    target.searchParams.set('return_to', source);
    if (link.href !== target.href) link.href = target.href;
  }

  function decorateWithin(node) {
    if (!(node instanceof Element)) return;
    if (node.matches('a[href]')) decorateLink(node);
    node.querySelectorAll('a[href]').forEach(decorateLink);
  }

  function renderReturnButton() {
    if (!config.isShippingPage || !shippingUrl(window.location.href)) return;
    const explicit = productUrl(new URL(window.location.href).searchParams.get('return_to'));
    const destination = explicit || storedProduct() || productUrl(document.referrer);
    if (!destination) return;

    const container = document.querySelector('.wallify-delivery-page, .shopify-policy__body');
    if (!container || container.querySelector('[data-wallify-delivery-return]')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'wallify-delivery-return';
    wrapper.setAttribute('data-wallify-delivery-return', '');
    const link = document.createElement('a');
    link.href = destination;
    const arrow = document.createElement('span');
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = '←';
    const label = document.createElement('span');
    label.textContent = config.label || 'Back to product';
    link.append(arrow, label);
    wrapper.append(link);
    container.append(wrapper);
  }

  function prepareNavigation(event) {
    const target = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!target || !shippingUrl(target.getAttribute('href'))) return;
    const source = currentProduct();
    if (!source) return;
    decorateLink(target);
    rememberProduct(source);
  }

  if (config.isProduct) {
    rememberProduct(currentProduct());
    decorateWithin(document.body);
    ['pointerdown', 'click', 'auxclick', 'contextmenu', 'focusin'].forEach((type) => {
      document.addEventListener(type, prepareNavigation, true);
    });
    window.addEventListener('popstate', () => {
      rememberProduct(currentProduct());
      decorateWithin(document.body);
    });
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach(decorateWithin));
    }).observe(document.body, { childList: true, subtree: true });
  }

  renderReturnButton();
  document.addEventListener('shopify:section:load', renderReturnButton);
})();

